var React = require('react');

function CalendarAdd (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 1.681c.415 0 .752.319.752.712v.71h4.497v-.71c0-.393.336-.712.751-.712s.752.319.752.712v.71h1.498c.597 0 1.17.224 1.592.624.422.4.66.943.66 1.509v4.974c0 .394-.337.712-.752.712S15 10.604 15 10.21V8.79H3.002v6.395c0 .188.078.369.219.502a.77.77 0 0 0 .53.208h6c.414 0 .75.319.75.712 0 .393-.336.712-.75.712h-6c-.598 0-1.17-.225-1.593-.625-.422-.4-.659-.943-.659-1.509v-9.95c0-.565.237-1.108.66-1.508.422-.4.994-.625 1.591-.625H5.25v-.71c0-.392.336-.711.751-.711zM5.25 4.526H3.75a.77.77 0 0 0-.53.208.691.691 0 0 0-.218.502v2.13h11.997v-2.13a.691.691 0 0 0-.22-.502.77.77 0 0 0-.529-.208h-1.498v.71c0 .393-.337.712-.752.712s-.751-.32-.751-.712v-.71H6.752v.71c0 .393-.337.712-.752.712s-.751-.32-.751-.712v-.71zm9.001 7.105c.415 0 .752.318.752.712v1.42H16.5c.415 0 .752.319.752.712 0 .393-.337.712-.752.712h-1.498v1.42c0 .393-.337.712-.752.712s-.751-.32-.751-.712v-1.42H12c-.415 0-.751-.32-.751-.712 0-.393.336-.712.751-.712H13.5v-1.42c0-.394.336-.712.751-.712z"}));
}

CalendarAdd.displayName = "CalendarAdd";

CalendarAdd.defaultProps = {"viewBox":"0 0 18 19"};

module.exports = CalendarAdd;

CalendarAdd.default = CalendarAdd;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/calendar-add.svg
// module id = 1260
// module chunks = 0